import { render, staticRenderFns } from "./KBLogoWithGradient.vue?vue&type=template&id=0e6dc2d9&scoped=true&"
import script from "./KBLogoWithGradient.vue?vue&type=script&lang=js&"
export * from "./KBLogoWithGradient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6dc2d9",
  null
  
)

export default component.exports